import { render, staticRenderFns } from "./MSSafe.vue?vue&type=template&id=3424495a&scoped=true"
import script from "./MSSafe.vue?vue&type=script&lang=js"
export * from "./MSSafe.vue?vue&type=script&lang=js"
import style0 from "./MSSafe.vue?vue&type=style&index=0&id=3424495a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424495a",
  null
  
)

export default component.exports